import React from "react";
import BoxBackground from "../../assets/get-demo-box-bg.jpg";
import { Link, useLocation } from "react-router-dom";
import SupportIcon from "../../assets/support.svg";

function AskusAnythingBox() {
  const location = useLocation();

  const handleClick = (e) => {
    if (location.pathname === "/contact-us") {
      e.preventDefault(); // Prevent re-navigation
      window.scrollTo({ top: 0, behavior: "smooth" }); // Smooth scroll to top
    }
  };

  return (
    <div className="w-full lg:w-1/2 max-w-full px-4">
      <div
        className="p-6 sm:p-10 lg:p-14 rounded-[21px] bg-no-repeat bg-cover bg-center h-full"
        style={{
          backgroundImage: `url(${BoxBackground})`,
        }}
      >
        <div className="flex flex-col gap-4 mb-6">
          <img
            src={SupportIcon}
            alt="Laguna Creek Logo"
            className="h-auto"
            height="56"
            width="56"
          />
          <h3 className="text-2xl sm:text-3xl font-normal leading-10 text-[#121212]">
            Ask us anything...{" "}
          </h3>
          <p className="text-lg font-light leading-7 text-[#333333]">
            (and chat with a real human)
          </p>
        </div>
        <Link
          to="/contact-us"
          onClick={handleClick}
          className="inline-block text-lg font-bold leading-6 text-white bg-[#5fa3b2] py-4 px-9 rounded-xl transition-all ease-in-out duration-500 hover:bg-[#FAA42A]"
        >
          Get Answers 
        </Link>
      </div>
    </div>
  );
}

export default AskusAnythingBox;
